import { Component, EventEmitter, Input, OnChanges, OnInit, Output, SimpleChanges, ViewChild } from '@angular/core';
import { CommonModule } from '@angular/common';
import { LabelMode } from 'devextreme/common';
import { CtlGasBirimDosyaBelgeService } from './ctl-gas-birim-dosya-belge.service';
import { CtlSablonComponent } from '../ctl-sablon/ctl-sablon.component';
import { DxButtonModule, DxPopupModule, DxScrollViewModule, DxToastModule } from 'devextreme-angular';
import { CtlGasBirimDosyaBelgeAramaComponent } from './ctl-gas-birim-dosya-belge-arama/ctl-gas-birim-dosya-belge-arama.component';
import { UtilsService } from '../../../services/utils.service';
import { OrtakService } from '../../../services/ortak.service';

@Component({
  selector: 'dk-ctl-gas-birim-dosya-belge',
  standalone: true,
  imports: [CommonModule,CtlGasBirimDosyaBelgeAramaComponent,CtlSablonComponent,DxPopupModule,DxButtonModule, DxScrollViewModule, DxToastModule],
  templateUrl: './ctl-gas-birim-dosya-belge.component.html',
  styleUrls: ['./ctl-gas-birim-dosya-belge.component.scss'],
})
export class CtlGasBirimDosyaBelgeComponent implements OnInit,OnChanges {
  @ViewChild(CtlSablonComponent) ctlSablonComponent: CtlSablonComponent;
  @Input() labelText = "";
  @Input() labelMode: LabelMode = null;
  public crudPopupVisible = false;
  public toastMessage: string;
  public showAction = true;
  public title!: string;
public isFirst = true;
  public control!: any;
  controlName = "GasBirimDosya";
  @Input() isReadOnly = false;
  @Input() isBindCheck = false;
  public data: any;
  @Input() code!: any;
  @Input() birim!: number;
  @Input() state: string;
  @Input() validationRulesMap:any[] = [];
  @Input() validationV2= false;
  @Input() warningMessage: string | null = null;
  @Output() public dataResult: EventEmitter<any> = new EventEmitter();

  constructor(private service: CtlGasBirimDosyaBelgeService, private utilsService: UtilsService, private ortakService: OrtakService) { }

  ngOnChanges(changes: SimpleChanges) {
    if (changes['birim']) {
      if (this.birim == null) this.showAction = false
      else {
        this.showAction = true
        this.service.setParams(this.birim,this.isReadOnly,this.isBindCheck)
      }
    }
    if (changes['isReadOnly'] || changes['isBindCheck']) {
        this.service.setParams(this.birim,this.isReadOnly,this.isBindCheck)
      }
  }

  ngOnInit(): void {
    if (this.controlName) {
      this.getControl();
    }
    if (!this.birim) {
      if(this.isFirst) this.showAction = false
    }
        this.service.setParams(this.birim,this.isReadOnly,this.isBindCheck)
  }
  getControl(){
    this.ortakService.getControl(this.controlName)
    .subscribe((data) => {
      this.control = data?.controlMetadata;
             //this.service.getDlist(this.control?.dlistCode);
      this.service._gridControlsList.next(data?.controlMetadata.dlistMetadata)
      //if(this.labelText === "")this.labelText = this.control.controlDescription;
        if(data?.controlMetadata.dlistMetadata.baseEntity){
          if(this.labelText === "")this.labelText = this.control.controlDescription;
          if(this.code && this.control) this.getData(this.code,true)
if(this.isFirst) this.isFirst = false;;
        }
    });
  }
  searchClick() {
    if (this.showAction) this.crudPopupVisible = true
  }

  clear() {
    this.title = '';
    this.code = '';
    this.data = null;
    this.dataResult.emit(null);
  }

  handleValueChange(e: any) {
    if (this.showAction) {
      if (e === '' || e === null) this.clear();
      else if(!this.isFirst) this.getData(e);
    this.isFirst = false;
    }
  }

  getData(code: any, isSetData?: boolean) {

    this.data = this.service.getData((code), this.birim,this.control,this.control.dlistMetadata.baseEntity,isSetData);
    this.data.load().done((result: any) => {
      if (result.length > 0) {
        this.title = result[0]?.GenDosyaPlan?.Ad;

        this.code = result[0]?.DosyaPlanKod;
        this.dataResult.emit(result[0]);
      } else if (this.code.length > 0) {
        this.utilsService.showError('Bulunamadı');
        this.clear();
      }
    });

  }

  closePopupAfter(result: any, sablonCmp: CtlSablonComponent) {
    if (result?.data) {
      this.data = result.data;
      this.title=this.data.GenDosyaPlan?.Ad;
      this.code = result.data?.DosyaPlanKod;
      this.dataResult.emit(this.data);
    } 
    this.crudPopupVisible = false;
    setTimeout(() => {
      sablonCmp.focusInput();
    });
  }

}
